module.exports = __webpack_public_path__ + "static/media/demo1.653b83ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/demo1.png
// module id = 945
// module chunks = 0